export const BLAST_ROLE_KEYS = ['coach', 'team_admin', 'parent', 'member', 'team_mom'] as const;
export type BlastRoleKey = (typeof BLAST_ROLE_KEYS)[number];

export const ROLE_LABELS: Record<BlastRoleKey, string> = {
  coach: 'Coaches',
  team_admin: 'Team admins',
  parent: 'Parents',
  team_mom: 'Team moms',
  member: 'Members',
};

export const ROLE_GROUPS: ReadonlyArray<{ heading: string; roles: readonly BlastRoleKey[] }> = [
  { heading: 'Coaches & staff', roles: ['coach', 'team_admin'] },
  { heading: 'Parents & family', roles: ['parent', 'team_mom', 'member'] },
];

/** Human summary of an attachment selector, in display order. */
export function summarizeSelector(selector: { blastRoles: readonly BlastRoleKey[]; crmContacts: boolean }): string {
  const parts: string[] = [];
  for (const group of ROLE_GROUPS) {
    for (const role of group.roles) {
      if (selector.blastRoles.includes(role)) parts.push(ROLE_LABELS[role]);
    }
  }
  if (selector.crmContacts) parts.push('CRM contacts');
  return parts.length ? parts.join(', ') : 'Nothing selected';
}
